import { FallbackPricingLink } from '@/constants';

export const LinkWrapperVariables: Record<string, string> = {
  CUSTOMER_DASHBOARD_URL: globalThis.branding.customerDashboardUrl ?? '',
  CUSTOMER_SUPPORT_URL: globalThis.branding.customerSupportUrl ?? '',
  CUSTOMER_SUPPORT_EMAIL: globalThis.branding.customerSupportEmail ?? '',
  CUSTOMER_SUPPORT_CONTACT_URL: globalThis.branding.customerSupportContactUrl ?? '',
};

export function replaceVariablesInLinkWrapper(
  url: string,
  variables: Record<string, string> = LinkWrapperVariables
): string {
  const trimLeadingSlashURL = url.startsWith('/${') ? url.slice(1) : url;
  if (globalThis.branding.pricing) {
    globalThis.branding.pricing.forEach(product => {
      LinkWrapperVariables[product.productName] = product.pricingUrl;
    });
  }
  const replacedText = Object.entries(variables).reduce(
    (text, [variable, value]) => text.replaceAll(`\${${variable}}`, value),
    trimLeadingSlashURL
  );
  const brand = globalThis.branding.vendorId;
  return replacedText.replace(/\$\{.*?_(PRICING)}/gi, FallbackPricingLink[brand] ?? '');
}
